import Breadcrumb from '../../../../components/base/Breadcrumb';
import PagesHeader from '../../../../components/base/PagesHeader';
import { IBreadCrumb } from '../../../../types/base/BreadCrumb';
import { Col, Row } from 'react-bootstrap';
import CardComponent from '../../../../components/base/CardComponent';
import { SpecialPayrollTaxChart } from './SpecialPayrollTaxChart';
import { SpecialPayrollTaxReport } from './SpecialPayrollTaxReport';

export const SpecialPayrollTax = () => {
  const breadcrumb: IBreadCrumb[] = [
    {
      name: 'Overview',
      href: '/dashboard',
    },
    {
      name: 'Reports',
      href: '/reports',
    },
    {
      name: 'Special Payroll Tax',
    },
  ];

  return (
    <>
      <Breadcrumb navItem={breadcrumb} />
      <Row className="d-flex">
        <Col md="6">
          <PagesHeader headingClass="fs-h1" pageTitle="Special Payroll Tax" />
        </Col>
      </Row>
      <CardComponent>
        <SpecialPayrollTaxChart />
        <SpecialPayrollTaxReport />
      </CardComponent>
    </>
  );
};
